import PropTypes from 'prop-types';

import ToggleBase from './ToggleBase';

import './styles/toggleSliderStyles.css';

const ToggleSlider = ({ children, ...props }) => (
  <ToggleBase
    className="toggle-slider bg-gray-2 rounded-4xl text-gray-6 inline-block overflow-hidden"
    {...props}
  >
    {children}
  </ToggleBase>
);

ToggleSlider.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
};

export default ToggleSlider;
